// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs--32zciLz8lz"};